export enum UserRole {
	Admin = 'admin',
	User = 'user',
	Bot = 'bot',
	LlmBot = 'llm_bot',
}
